"use client";

import { BackendButton } from "@/app/components/backend/backend-ui";
import type { QuickActionT } from "@/app/types/backend-table";

export type QuickActionsPropsT = {
  /** Array of quick actions to display */
  actions: QuickActionT[];
  /** Number of selected rows */
  selectedCount: number;
  /** Array of selected row IDs */
  selectedIds: string[];
  /** Clears the current selection */
  onClear?: () => void;
};

/**
 * QuickActions Component
 *
 * Bulk-action bar shown when table rows are selected: a dark bar with the
 * selection count on the left and the actions (plus "Aufheben" to clear) on
 * the right.
 */
export function QuickActions({
  actions,
  selectedCount,
  selectedIds,
  onClear,
}: QuickActionsPropsT) {
  if (selectedCount === 0 || actions.length === 0) {
    return null;
  }

  return (
    <div className="mt-3 flex flex-wrap items-center justify-between gap-3 rounded-[12px] bg-[var(--c-ink)] px-4 py-2.5">
      <span className="text-[13.5px] font-semibold text-white">
        {selectedCount} ausgewählt
      </span>

      <div className="flex flex-wrap items-center gap-2">
        {actions.map((action) => (
          <BackendButton
            key={action.id}
            variant="ghost"
            size="sm"
            className="h-8 gap-1.5 border-0 bg-white/10 px-3 text-[12.5px] font-semibold text-white hover:bg-white/20 hover:text-white"
            onClick={() => action.onClick(selectedIds)}
            disabled={action.disabled}
          >
            {action.icon}
            {action.loading
              ? action.loadingLabel || "Wird verarbeitet..."
              : action.label}
          </BackendButton>
        ))}

        {onClear && (
          <BackendButton
            variant="ghost"
            size="sm"
            className="h-8 border-0 bg-transparent px-3 text-[12.5px] font-semibold text-white/60 hover:bg-transparent hover:text-white"
            onClick={onClear}
          >
            Aufheben
          </BackendButton>
        )}
      </div>
    </div>
  );
}
